import { render } from "./view-full-text-modal.vue?vue&type=template&id=84990e4c"
import script from "./view-full-text-modal.vue?vue&type=script&lang=js"
export * from "./view-full-text-modal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__